module.exports = __webpack_public_path__ + "static/media/3DVAM-mobile.bbb7435e.png";